module.exports = __webpack_public_path__ + "static/media/SellkeyMain02.e9df991f.png";